import { createSlice } from 'utils/@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';
import { useInjectReducer } from 'utils/redux-injectors';
import { State } from './types';
import { endpoints, baseQuery } from 'utils/api/endpoints';

export const initialState: State = {};

const slice = createSlice({
  name: 'settings',
  initialState,
  reducers: {},
});

export const api = createApi({
  reducerPath: 'settingsApi',
  baseQuery,
  tagTypes: ['siteSettings'],
  endpoints: builder => ({
    saveSiteSettings: builder.mutation({
      query: data => ({
        url: endpoints.SETTINGS + '/update',
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['siteSettings'],
    }),
    getSiteSettings: builder.query<any, void>({
      query: () => ({
        url: endpoints.SETTINGS,
        method: 'GET',
      }),
      providesTags: ['siteSettings'],
    }),
  }),
});

export const { actions: settingsActions } = slice;

export const useSettingsSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  return {
    actions: settingsActions,
    useSaveSiteSettingsMutation: api.useSaveSiteSettingsMutation,
    useGetSiteSettingsQuery: api.useLazyGetSiteSettingsQuery,
  };
};
